<div class="bl-user-button">
  <a class="user" (click)="menu.toggle($event); hideAndShow()" [title]="user.userName">
    <span *ngIf="user?.userName" class="bl-user-button__email">{{ user.userName }}</span>
    <span *ngIf="user?.userName === ''" class="bl-user-button__email"></span>
    <i class="fas fa-user-circle"></i>
    <div class="bl-user-button__pos-arrow-up">
      <i class="fas fa-sort-down"></i>
    </div>
  </a>
  <div class="bl-slide-menu bl-slide-menu--medium-size">
    <p-slideMenu #menu [model]="items" [popup]="true"></p-slideMenu>
  </div>
</div>
